export default { version: '6.0.33' };
